import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject13() {
  var data = _taggedTemplateLiteralLoose(["\n      display: none;\n    "]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteralLoose(["\n      > svg:first-child {\n        transform: translate(-1px, 10px);\n      }\n\n      > svg:last-child {\n        transform: translate(-1px, -10px) rotate(180deg);\n      }\n    "]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteralLoose(["\n  border: 0;\n  border-radius: 50%;\n  width: 60;\n  height: 60;\n  position: fixed;\n  right: ", ";\n  bottom: ", ";\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  color: bg;\n  background-color: text;\n  transition: base;\n  transition-property: color;\n  box-shadow: ", " 0 0 ", ";\n  appearance: none;\n\n  &:focus {\n    outline: none;\n    color: bg;\n  }\n\n  > svg:first-child {\n    transition: transform 200ms ease-in-out;\n    transform: translateX(-1px);\n  }\n\n  > svg:last-child {\n    transition: transform 200ms ease-in-out;\n    transform: translate(-1px) rotate(180deg);\n  }\n\n  ", "\n\n  ", "\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteralLoose(["\n      padding-top: 0;\n      position: fixed;\n      height: calc(100vh - 70px);\n      overflow-y: auto;\n      z-index: 2;\n      margin-right: -999;\n      padding-right: 999;\n      background-color: secondary-bg;\n    "]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteralLoose(["\n      flex: 0 0 ", ";\n      margin-left: 50;\n    "]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteralLoose(["\n      overflow-y: visible;\n      height: auto;\n      pointer-events: auto;\n      transform: none;\n      width: auto;\n      opacity: 1;\n      position: relative;\n      transform: none;\n      flex: 0 0 ", ";\n      margin-left: 16;\n    "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteralLoose(["\n      pointer-events: auto;\n      transform: translateY(0);\n      opacity: 1;\n    "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteralLoose(["\n  background-color: secondary-bg;\n  border-left: 1;\n  border-color: border;\n  transition: base;\n  transition-property: transform, opacity;\n  position: fixed;\n  opacity: 0;\n  height: 100vh;\n  width: 100vw;\n  transform: translateY(", ");\n  pointer-events: none;\n  overflow-y: auto;\n\n  ", "\n\n  ", "\n\n  ", "\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n  flex-grow: 1;\n  padding: 0 20 50;\n  overflow: hidden;\n  word-wrap: break-word;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  width: 100%;\n  position: relative;\n  z-index: 0;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n      float: right;\n      display: block;\n      margin-right: -20px;\n    "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  display: none;\n\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import styled, { css, up, th } from '@xstyled/styled-components';
import { Container } from './Container';
import { Sidebar } from './Sidebar';
import { BaseLayout } from './BaseLayout';
import { Article } from './Article';
import { MenuProvider, MenuConsumer } from './MenuContext';
import ChevronUpSolid from './icons/ChevronUpSolid';
import { CarbonAd } from './CarbonAd';
var FloatingAd = styled.div(_templateObject(), up('md', css(_templateObject2())));
var Wrapper = styled.div(_templateObject3());
var ArticleContainer = styled.div(_templateObject4());
var SidebarContainer = styled.div(_templateObject5(), th.size(50), function (p) {
  return p.opened && css(_templateObject6());
}, up('sm', css(_templateObject7(), th.size(180))), up('lg', css(_templateObject8(), th.size(230))));
var SidebarWrapper = styled.div(_templateObject9(), up('sm', css(_templateObject10())));
var MenuButton = styled.button(_templateObject11(), th.size(8), th.size(8), th.color('menu-button-shadow'), th.size(20), function (p) {
  return p.active && css(_templateObject12());
}, up('sm', css(_templateObject13())));
export function DocLayout(_ref) {
  var children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, ["children"]);

  return /*#__PURE__*/React.createElement(MenuProvider, null, /*#__PURE__*/React.createElement(BaseLayout, Object.assign({
    variant: "light"
  }, props), /*#__PURE__*/React.createElement(Container, {
    px: 0
  }, /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement(ArticleContainer, null, /*#__PURE__*/React.createElement(Article, null, /*#__PURE__*/React.createElement(FloatingAd, null, /*#__PURE__*/React.createElement(CarbonAd, null)), children)), /*#__PURE__*/React.createElement(MenuConsumer, null, function (_ref2) {
    var opened = _ref2.opened,
        toggle = _ref2.toggle;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SidebarContainer, {
      opened: opened
    }, /*#__PURE__*/React.createElement(SidebarWrapper, null, /*#__PURE__*/React.createElement(Sidebar, null))), /*#__PURE__*/React.createElement(MenuButton, {
      active: opened,
      onClick: toggle
    }, /*#__PURE__*/React.createElement(ChevronUpSolid, {
      width: 15,
      height: 15
    }), /*#__PURE__*/React.createElement(ChevronUpSolid, {
      width: 15,
      height: 15
    })));
  })))));
}